export default {
  'introThanks': 'Vielen Dank, dass Sie uns mit Ihrem Feedback dabei unterstützen besser zu werden!',
  'customerFirstname': 'Vorname',
  'customerLastname': 'Nachname',
  'customerEmail': 'E-Mail',
  'customerTitle': 'Titel',
  'visitFrom': 'Tag der Anreise',
  'visitTo': 'Tag der Abreise',
  'visitRoom': 'Zimmernummer',
  'salutationOptionMr': 'Herr',
  'salutationOptionMrs': 'Frau',
  'salutationOptionFamily': 'Familie',
  'btnStart': 'Start',
  'thanksTitle': 'Vielen Dank!',
  'thanksTextFinish': 'Eilige können den Fragebogen jetzt...',
  'thanksBtnFinish': 'Abschliessen',
  'thanksTextContinue': '... wenn Sie aber noch ein paar Minuten Zeit hätten, würde wir Ihnen noch gerne ein paar weitere detaillierte Fragen stellen',
  'thanksBtnContinue': 'Weitere Fragen',
  'selectChooseOption': 'Bitte wählen Sie...',
  'btnNext': 'Weiter',
  'btnSkip': 'Überspringen',
  'btnFeedback': 'Kommentar',
  'selectorTextThanks': 'Super, vielen Dank für Ihre Unterstützung!',
  'selectorTextSelect': 'Welche der folgenden Angebote haben Sie genutzt?',
  'feedbackTitle': 'Ihr Kommentar zum Thema',
  'feedbackPositiveTitle': 'Was war positiv?',
  'feedbackNegativeTitle': 'Was war negativ?',
  'smileyVeryHappy': 'Sehr zufrieden',
  'smileyHappy': 'Zufrieden',
  'smileyMedium': 'Mittelmaß',
  'smileyUnhappy': 'Unzufrieden',
  'smileyVeryUnhappy': 'Sehr unzufrieden',
  'smileyNotScored': 'Nicht bewertet',
  'validationMessageEmail': 'Bitte geben Sie eine gültige Email-Adresse an',
  'validationMessageRequired': '"Pflichtfeld"',
  'txtAppStart': 'Lade Umfrage...',
  'selectorTitle': 'Nutzung unserer Angebote',
  'finalThanksTitle': 'Herzlichen Dank für Ihre Anregungen',
  'finalThanksHolidayCheckIntro': 'Dürfen wir ein Teil Ihrer Bewertung auch an HolidayCheck weitergeben?<br />Sie würden uns einen großen Gefallen tun! Auf der nächsten Seite zeigen wir Ihnen eine Zusammenfassung Ihrer Daten, die wir, Ihrer Erlaubnis vorrausgesetzt, zu HolidayCheck übertragen würden.<br /><br />Es sind nur wenige Klicks & Ergänzungen – dann haben Sie es geschafft.',
  'finalThanksHolidayCheckBtn': 'HolidayCheck - Zusammenfassung anzeigen',
  'pickDate': '... auswählen',
  'surveyFinishedTitle': 'Umfrage beendet',
  'surveyAlreadyDone': 'Sie haben an dieser Umfrage bereits teilgenommen, vielen Dank!',
  'legendPrimerPositive': 'vollkommen zufrieden',
  'legendPrimerNegative': 'Sehr unzufrieden',
  'hcTitle_recommendation': 'Empfehlen Sie das Hotel weiter?',
  'hcTitle_title': 'Wie lautet der Titel Ihrer Bewertung?',
  'hcTitle_text': 'Beschreiben Sie das Hotel ganz allgemein',
  'hcDescription_text': 'Beschreiben Sie in 2-3 Sätzen Ihren ersten Eindruck vom Hotel. War es z.B. für Ihren Reisegrund geeignet?',
  'hcFilledHint': 'Bitte füllen Sie alle Felder aus',
  'hcTitle_age': 'Wie alt sind sie?',
  'hcTitle_traveledWith': 'Mit wem sind Sie verreist?',
  'hcTitle_travelDuration': 'Aufenthaltslänge',
  'hcOption_traveledWith_friends': 'Freunde',
  'hcOption_traveledWith_family': 'Familie',
  'hcOption_traveledWith_couple': 'Paar',
  'hcOption_traveledWith_single': 'Allein',
  'hcOption_children_no': 'keine',
  'hcOption_children_one': '1',
  'hcOption_children_two': '2',
  'hcOption_children_three': '3',
  'hcOption_children_four': '4',
  'hcOption_children_more': 'mehr als 4',
  'hcOption_age_14-18': '16 - 18',
  'hcOption_age_19-25': '19 - 25',
  'hcOption_age_26-30': '26 - 30',
  'hcOption_age_31-35': '31 - 35',
  'hcOption_age_36-40': '36 - 40',
  'hcOption_age_41-45': '41 - 45',
  'hcOption_age_46-50': '46 - 50',
  'hcOption_age_51-55': '51 - 55',
  'hcOption_age_56-60': '56 - 60',
  'hcOption_age_61-65': '61 - 65',
  'hcOption_age_66-70': '66 - 70',
  'hcOption_age_70 >': '70+',
  'hcOption_ratingCostPerformance_poor': 'Sehr schlecht',
  'hcOption_ratingCostPerformance_bad': 'Eher schlecht',
  'hcOption_ratingCostPerformance_medium': 'Angemessen',
  'hcOption_ratingCostPerformance_good': 'Eher gut',
  'hcOption_ratingCostPerformance_great': 'Sehr gut',
  'hcOption_travelReason_business': 'Arbeit',
  'hcOption_travelReason_city': 'Stadt',
  'hcOption_travelReason_wellness': 'Wellness',
  'hcOption_travelReason_winter': 'Winter',
  'hcOption_travelReason_other': 'Sonstiges',
  'hcOption_travelReason_beach': 'Strand',
  'hcOption_travelDuration_1-3 days': '1 -3 Tage',
  'hcOption_travelDuration_3-5 days': '3 - 5 Tage',
  'hcOption_travelDuration_1 week': '1 Woche',
  'hcOption_travelDuration_2 weeks': '2 Wochen',
  'hcOption_travelDuration_3 weeks': 'Länger als 2 Wochen',
  'hcCardTitle': 'Holidaycheck Bewertungs-Übertragung',
  'btnSubmit': 'Abschicken',
  'requiredField': 'Pflichtfeld',
  'topicTitle': 'Anderes Thema?',
  'topicHint': 'Wählen Sie das Thema aus, zu dem Sie einen Kommentar hinterlassen möchten',
  'txtSuggestFeedback': 'Ihr Kommentar dazu wäre toll :-)',
  'txtFiguresPercent': 'Angaben in Prozent',
  'hcPrivacyHint': 'Die Informationen zum Datenschutz gemäß Art. 13 und 14 DSGVO finden Sie hier <a href="https://www.holidaycheck.de/datenschutz" target="_blank">Link zum Datenschutz von HolidayCheck</a>.',
  'hcConsentHint': ' Ich erkläre mich damit einverstanden, dass meine angegebenen persönlichen Daten sowie die Bewertung zu HolidayCheck übertragen und veröffentlicht wird und akzeptiere die <a  target="_blank" href="https://www.holidaycheck.de/nutzungsbedingungen">Nutzungsbedingungen</a> von HolidayCheck',
  'txtImpress': 'Impressum',
  'linkImpress': 'https://www.vioma.de/de/service/impressum/',
  'txtPrivacy': 'Datenschutzerklärung',
  'txtPrivacyConsent': 'Ich stimme zu, dass meine Angaben aus der Umfrage zur Verbesserung der Qualität erhoben und verarbeitet werden. Die Daten werden 24 Monate nach dem Absenden gelöscht. Sie können Ihre Einwilligung jederzeit per E-Mail an <a href="mailto:%{mail}">%{mail}</a> widerrufen. Detaillierte Informationen zum Umgang mit Nutzerdaten finden Sie in unserer <a href="%{link}" target="_blank">Datenschutzerklärung</a>.',
  'txtPrivacyHint': 'Ich stimme zu, dass mein Fazit auf der Webseite des Unternehmens und auf der Bewertungsseite unter <a href="%{link}" target="_blank">%{link}</a> mit meinem Geschlecht, meinem abgekürztem Namen, meiner Stadt sowie dem Datum der Abgabe des Fazits veröffentlicht wird. Diese Einwilligung kann ich jederzeit unter <a href="mailto:%{mail}">%{mail}</a> widerrufen. Das veröffentlichte Fazit wird dann gelöscht',
  'txtExample': 'Beispiel',
  'txtSkip': 'Überspringen',
  'txtPrivacyValidationHint': 'Ohne Zustimmung können wir den Text nicht verarbeiten',
  'btnDifferentTopic': 'Anderes Thema',
  'btnOK': 'OK'
}



// WEBPACK FOOTER //
// ./src/languages/de.js